module.exports = __webpack_public_path__ + "img/Light Cloud.1a6d4ff5.png";